module.exports = __webpack_public_path__ + "img/company_07.b4edd2bc.png";